export enum MessageResendRecipientsEnum {
  All = 0,
  UnopenedOnly = 1,
}
